(function($)
{

    $.formbuilder = function(method, options) {
        // build main options before element iteration
        // Method calling logic
        var opts;
        if(methods[method])
        {
            opts = $.extend({}, $.formbuilder.defaults, options);
        }
        else
        {
            $.error('Method ' + method + ' does not exist on jQuery.formbuilder');
        }


        return this.each(function() {
             var $this = $(this);
             // build element specific options
             var eOpts = $.metadata ? $.extend({}, opts, $this.metadata()) : opts;
             eOpts = $.fn.dataset ? $.extend({}, eOpts, $this.dataset()) : eOpts;

             // Method calling logic
             if(methods[method])
             {
                 return methods[ method ].call(this, eOpts);
             }
         });
    };
    //
    // Methods
    //
    var methods = {
        'info-message' : function(options) {
            var $message = $('<p></p>').text(getText(options)).addClass('message icon ui-state-highlight').attr('data-icon', 'ui-icon-info');
            $message.msxiicon();
            return $message;
        },
        'error-message' : function(options) {
            var $message = $('<p></p>').text(getText(options)).addClass('message icon ui-state-error').attr('data-icon', 'ui-icon-alert');
            $message.msxiicon();
            return $message;
        }
    };
    //
    // plugin defaults
    //
    $.formbuilder.defaults = {
        traslate:true
    };

    function getText(options) {
        var text;
        if (options[translate]) {
            text = translate(options['text']);
        } else {
            text = options['text'];
        }
        return text;
    }
})(jQuery);